import {
  IMetricsContext,
  ICausesResponse,
  IMetricsOnboardingByPeriod,
  IMetricsRanking,
  IMetricsBetterfliesRanking,
  IMetricsBenefits,
  IMetricsDonationsSummary,
  IMetricsChallengesSummary,
  IMetricsChallengeByType,
  IMetricsChallengeRanking,
  IMetricsChallengeRankingEntry,
  IMetricsDonationsChartData,
  IMetricsProtectionByCases,
  IMetricsProtectionCoverage,
  IMetricsProtectionInsurance
} from '../interfaces/metrics';

export const FOUNDATION_WEBSITE_URL_MOCK = 'https://google.com';

export const MOCK_CAUSES_RESPONSE: ICausesResponse = {
  12: {
    name: 'Leche para Haití',
    img: 'https://imgflip.com/s/meme/Third-World-Skeptical-Kid.jpg',
    description: 'key de lokalise',
    foundation: {
      name: 'foundation 1',
      img: 'https://api.izeelogo.com/categoriepage/logo/crear-logos-empresariales/disenos-de-logos-de-empresas-de-tecnologia.png',
      websiteLink: FOUNDATION_WEBSITE_URL_MOCK
    },
    global: {
      donationsGoal: 12000,
      missingDonations: 2000,
      donations: 10000,
      donationsProgress: 83
    },
    history: {
      totalDonations: 63,
      donationsMaxValue: 550,
      percentageChart: 50.0,
      donations: [
        {
          date: {
            firstDay: '2019-01-01',
            lastDay: '2019-01-07'
          },
          amount: 100
        },
        {
          date: {
            firstDay: '2019-01-07',
            lastDay: '2019-01-14'
          },
          amount: 500
        },
        {
          date: {
            firstDay: '2019-01-14',
            lastDay: '2019-01-21'
          },
          amount: 400
        },
        {
          date: {
            firstDay: '2019-01-21',
            lastDay: '2019-01-28'
          },
          amount: 450
        }
      ]
    },
    donationType: 'cause.donation_type.meals',
    donationEquivalence: 0
  },
  34: {
    name: 'Arboles para Haití',
    img: 'https://mejorconsalud.as.com/wp-content/uploads/2018/04/consejos-para-plantar-arbol.jpg',
    description: 'key de lokalise',
    foundation: {
      name: 'foundation 1',
      img: 'https://api.izeelogo.com/categoriepage/logo/crear-logos-empresariales/disenos-de-logos-de-empresas-de-tecnologia.png',
      websiteLink: FOUNDATION_WEBSITE_URL_MOCK
    },
    global: {
      donationsGoal: 12000,
      missingDonations: 2000,
      donations: 10000,
      donationsProgress: 83
    },
    history: {
      totalDonations: 96,
      donationsMaxValue: 550,
      percentageChart: 50.0,
      donations: [
        {
          date: {
            firstDay: '2019-01-01',
            lastDay: '2019-01-07'
          },
          amount: 200
        },
        {
          date: {
            firstDay: '2019-01-01',
            lastDay: '2019-01-07'
          },
          amount: 400
        },
        {
          date: {
            firstDay: '2019-01-01',
            lastDay: '2019-01-07'
          },
          amount: 500
        }
      ]
    },
    donationType: 'cause.donation_type.trees',
    donationEquivalence: 0
  },
  35: {
    name: 'Arboles para Haití x3',
    img: 'https://mejorconsalud.as.com/wp-content/uploads/2018/04/consejos-para-plantar-arbol.jpg',
    description: 'key de lokalise',
    foundation: {
      name: 'foundation 1',
      img: 'https://api.izeelogo.com/categoriepage/logo/crear-logos-empresariales/disenos-de-logos-de-empresas-de-tecnologia.png',
      websiteLink: FOUNDATION_WEBSITE_URL_MOCK
    },
    global: {
      donationsGoal: 12000,
      missingDonations: 2000,
      donations: 10000,
      donationsProgress: 83
    },
    history: {
      totalDonations: 56,
      donationsMaxValue: 550,
      percentageChart: 50.0,
      donations: [
        {
          date: {
            firstDay: '2019-01-01',
            lastDay: '2019-01-07'
          },
          amount: 200
        },
        {
          date: {
            firstDay: '2019-01-01',
            lastDay: '2019-01-07'
          },
          amount: 400
        },
        {
          date: {
            firstDay: '2019-01-01',
            lastDay: '2019-01-07'
          },
          amount: 500
        }
      ]
    },
    donationType: 'cause.donation_type.generic',
    donationEquivalence: 0
  },
  36: {
    name: 'Más Arboles para Haití',
    img: 'https://mejorconsalud.as.com/wp-content/uploads/2018/04/consejos-para-plantar-arbol.jpg',
    description: 'key de lokalise',
    foundation: {
      name: 'foundation 1',
      img: 'https://api.izeelogo.com/categoriepage/logo/crear-logos-empresariales/disenos-de-logos-de-empresas-de-tecnologia.png',
      websiteLink: FOUNDATION_WEBSITE_URL_MOCK
    },
    global: {
      donationsGoal: 12000,
      missingDonations: 2000,
      donations: 10000,
      donationsProgress: 83
    },
    history: {
      totalDonations: 23,
      donationsMaxValue: 550,
      percentageChart: 50.0,
      donations: [
        {
          date: {
            firstDay: '2019-01-01',
            lastDay: '2019-01-07'
          },
          amount: 200
        },
        {
          date: {
            firstDay: '2019-01-01',
            lastDay: '2019-01-07'
          },
          amount: 400
        },
        {
          date: {
            firstDay: '2019-01-01',
            lastDay: '2019-01-07'
          },
          amount: 500
        }
      ]
    },
    donationType: 'cause.donation_type.water',
    donationEquivalence: 0
  }
};

export const METRICS_CONTEXT_MOCK_VALUE: IMetricsContext = {
  changeSearchOptions: () => {
    /** */
  },
  searchOptions: {
    dateRange: ['2022-01-01', '2022-02-01'],
    period: 'annually'
  },
  changeCausesData: () => {
    /** */
  },
  causesData: MOCK_CAUSES_RESPONSE,
  changePeriodSelection: () => {
    /** */
  },
  periodSelection: {
    period: 'selectedMonth',
    month: '2024-09-01'
  }
};

export const MOCK_DOWNLOAD_FILE_RESPONSE = {
  data: {
    fileKey: 'FileMock',
    url: 'https://google.com'
  }
};

export const MOCK_METRICS_ONBOARDING_BY_PERIOD: IMetricsOnboardingByPeriod = {
  percentageMembersActive: 99,
  amountMembersActive: 269,
  amountMembersRegistered: 272,
  amountMembersSynchronized: 254,
  amountMembersInactive: 3,
  historicalMetrics: [
    {
      firstDay: '2024-08-05',
      lastDay: '2024-08-11',
      membersInvited: 264,
      membersOnboarded: 261,
      newOnboarded: 0
    },
    {
      firstDay: '2024-08-12',
      lastDay: '2024-08-18',
      membersInvited: 265,
      membersOnboarded: 262,
      newOnboarded: 1
    },
    {
      firstDay: '2024-08-19',
      lastDay: '2024-08-25',
      membersInvited: 266,
      membersOnboarded: 263,
      newOnboarded: 1
    },
    {
      firstDay: '2024-08-26',
      lastDay: '2024-09-01',
      membersInvited: 267,
      membersOnboarded: 265,
      newOnboarded: 2
    }
  ]
};

export const MOCK_METRICS_RANKING: IMetricsRanking = {
  rankingKey: [
    {
      id: 'q8tGrbNvfPcOIkMc25Dh',
      value: 9265,
      icon: 'https://dev.media.players-mgmt.platform.betterfly.com/players-photos/7d1580a9e3b1f202d7ffd22e35ec71a8c298ce9264a514d0b895d3b8bbaf9e32/display-photo-1703076846070-60x60.jpg',
      title: 'Juanguisssssss Gonzalezss'
    },
    {
      id: 'OgjeoszLgvl2YNWEITuu',
      value: 8853,
      icon: null,
      title: 'Javier Sáez'
    },
    {
      id: 'ORPXJ08xzqK6DuIFH1Qq',
      value: 5300,
      icon: null,
      title: 'Dasdas Asdasdas'
    },
    {
      id: 'Pq93Si0NldorGSvED7Ir',
      value: 4475,
      icon: null,
      title: 'Asda Asdas'
    },
    {
      id: 'dLQrplcqwMtj01Fsn9BY',
      value: 4472,
      icon: null,
      title: 'Jose Luis Escorcia'
    },
    {
      id: 'FGVy3SYifG810H6SgYR9',
      value: 4177,
      icon: null,
      title: 'Dgfdfgd Dfsfdsdfs'
    },
    {
      id: 'FDAg41oQJeyYwrWtQhLF',
      value: 3352,
      icon: null,
      title: 'Valentina Galaz'
    }
  ]
};

export const MOCK_METRICS_BETTERFLIES_RANKING: IMetricsBetterfliesRanking = {
  leaderboard: MOCK_METRICS_RANKING.rankingKey,
  pagination: {
    limit: 50,
    offset: 0,
    hasMore: false
  }
};

export const MOCK_METRICS_BENEFITS: IMetricsBenefits = {
  usePercentage: 32,
  topBenefits: [
    {
      id: 201,
      value: 31.8,
      name: 'Medismart',
      icon: 'https://static.gobetterfly.com/catalog/benefitcontent/icon_bf755639.png',
      intendedUses: 100
    },
    {
      id: 1,
      value: 20.9,
      name: 'Rufy',
      icon: 'https://static.techbetterfly.com/provider/logo_cacd1390.png',
      intendedUses: 100
    },
    {
      id: 2,
      value: 17.6,
      name: 'Busuu',
      icon: 'https://static.gobetterfly.com/catalog/benefitcontent/icon_8fd23306.png',
      intendedUses: 100
    },
    {
      id: 3,
      value: 8.9,
      name: 'Chubb',
      icon: 'https://static.techbetterfly.com/provider/logo_a413fbc9.png',
      intendedUses: 100
    },
    {
      id: 397,
      value: 8.9,
      name: 'Udemy',
      icon: 'https://static.gobetterfly.com/catalog/benefitcontent/icon_c6995926.png',
      intendedUses: 100
    },
    {
      id: 894,
      value: 4.7,
      name: 'Fiton',
      icon: 'https://static.gobetterfly.com/catalog/benefitcontent/icon_456928eb.png',
      intendedUses: 100
    },
    {
      id: 4,
      value: 4.5,
      name: 'Conexa',
      icon: 'https://static.techbetterfly.com/provider/logo_ddbb5d9a.png',
      intendedUses: 100
    },
    {
      id: 8,
      value: 2.5,
      name: 'Wited',
      icon: 'https://static.gobetterfly.com/catalog/benefitcontent/icon_fad447fc.png',
      intendedUses: 100
    }
  ]
};

export const MOCK_METRICS_DONATIONS_RANKING: IMetricsRanking = {
  rankingKey: [
    {
      id: 'other',
      value: 3,
      icon: 'other',
      title: 'other'
    },
    {
      id: 'food',
      value: 2,
      icon: 'food',
      title: 'food'
    },
    {
      id: 'trees',
      value: 1,
      icon: 'trees',
      title: 'trees'
    }
  ]
};

export const MOCK_METRICS_DONATIONS_SUMMARY: IMetricsDonationsSummary = {
  totalDonations: '100',
  foundationsAmount: 500
};

export const MOCK_METRICS_CHALLENGES_SUMMARY: IMetricsChallengesSummary = {
  currentMonth: {
    activeChallenges: 48,
    totalParticipants: 53,
    participationRate: 0.4,
    completionRate: 0.6,
    betterfliesGiven: 95843
  },
  previousMonth: {
    activeChallenges: 0,
    totalParticipants: 56,
    participationRate: 0.4,
    completionRate: 0.6,
    betterfliesGiven: 116081
  }
};

export const MOCK_METRICS_CHALLENGES_BY_TYPE: IMetricsChallengeByType[] = [
  {
    type: 'steps',
    name: 'Pasos',
    icon: 'https://static.gobetterfly.com/b2b/metrics/challenges/steps.svg',
    participationRate: 0.3,
    participants: 47
  },
  {
    type: 'training',
    name: 'Entrenamiento',
    icon: 'https://static.gobetterfly.com/b2b/metrics/challenges/training.svg',
    participationRate: 0.3,
    participants: 40
  },
  {
    type: 'donations',
    name: 'Donaciones',
    icon: 'https://static.gobetterfly.com/b2b/metrics/challenges/donations.svg',
    participationRate: 0.3,
    participants: 40
  },
  {
    type: 'meditation',
    name: 'Meditación',
    icon: 'https://static.gobetterfly.com/b2b/metrics/challenges/meditation.svg',
    participationRate: 0.1,
    participants: 20
  }
];

const MOCK_STEPS_RANKING_TAIL: IMetricsChallengeRankingEntry[] = Array.from({ length: 25 }, (_, index) => {
  const rank = index + 6;
  const value = rank === 30 ? 0 : 70000 - index * 2800;
  const previousValue = 60000 - index * 1500;
  return {
    rank,
    name: `González, Persona ${rank}`,
    value,
    previousValue,
    variationPct: Math.round(((value - previousValue) / previousValue) * 10000) / 100
  };
});

export const MOCK_METRICS_CHALLENGES_RANKING: IMetricsChallengeRanking[] = [
  {
    type: 'steps',
    entries: [
      { rank: 1, name: 'Silva, Ana Paula', value: 284197.0, previousValue: 276115.0, variationPct: 2.93 },
      { rank: 2, name: 'Ramírez, Diego', value: 121555.75, previousValue: null, variationPct: null },
      { rank: 3, name: 'Pérez, Camila', value: 98450, previousValue: 105200, variationPct: -6.42 },
      { rank: 4, name: null, value: 87210, previousValue: 87210, variationPct: 0 },
      { rank: 5, name: 'Morales', value: 76000, previousValue: 0, variationPct: null },
      ...MOCK_STEPS_RANKING_TAIL
    ]
  },
  {
    type: 'donations',
    entries: [
      { rank: 1, name: 'Rojas, Valentina', value: 12, previousValue: 8, variationPct: 50 },
      { rank: 2, name: 'Fuentes, Tomás', value: 5, previousValue: 9, variationPct: -44.44 }
    ]
  },
  { type: 'training', entries: [] },
  {
    type: 'meditation',
    entries: [{ rank: 1, name: 'Castro, Isidora', value: 340, previousValue: null, variationPct: null }]
  }
];

export const MOCK_METRICS_DONATIONS_BY_CAUSES: IMetricsDonationsChartData = {
  causes: [
    {
      id: '055af90b-b1b2-4450-918e-f59323a2aae5',
      name: 'Teletón',
      value: 50.0,
      icon: ''
    },
    {
      id: 'fddf5eb3-2305-4175-a91f-4c6ec3903e82',
      name: 'Hogar de Cristo',
      value: 33.3,
      icon: ''
    },
    {
      id: '4e578ce4-2a63-4e5a-afa5-da79391f4e84',
      name: 'Trees for the Future',
      value: 16.7,
      icon: ''
    }
  ]
};

export const MOCK_METRICS_PROTECTION: IMetricsProtectionByCases = {
  case: 'dynamic',
  currency: 'UF',
  percentageInsured: 75,
  totalMembers: 10,
  totalInsuredMembers: 4,
  averageCoveragePerMember: 1200,
  initialCoverageGrowth: 5,
  teamCoverageGrowth: 7,
  initialCoverageGrowthDiff: 2,
  teamCoverageGrowthDiff: 3
};

export const MOCK_METRICS_PROTECTION_COVERAGE: IMetricsProtectionCoverage = {
  baseCoverage: 500,
  totalCoverage: 1000,
  currency: 'CLP',
  periods: [
    { earnedAmount: 200, startDate: '2024-10-31', endDate: '2024-11-07' },
    { earnedAmount: 200, startDate: '2024-10-24', endDate: '2024-10-30' },
    { earnedAmount: 200, startDate: '2024-10-17', endDate: '2024-10-23' },
    { earnedAmount: 200, startDate: '2024-10-10', endDate: '2024-10-16' },
    { earnedAmount: 200, startDate: '2024-11-01', endDate: '2024-11-08' }
  ]
};

export const MOCK_METRICS_PROTECTION_INSURANCE: IMetricsProtectionInsurance = {
  insight: 2,
  useIntentionRate: 1
};
